import { request } from '@/utils/request'
/**
 * 获取考试介绍详情
 */
export function getQueryList(params) {
  return request({
    url: `/examUser/user/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params
  })
}

/* 缴费 */
export function getPay(examId) {
  return request({
    url: `/alipay/${examId}`,
    method: 'post'
  })
}
//获取已经报名详情
export function getSigupInfo(id) {
  return request({
    url: `/examUser/${id}`,
    method: 'get'
  })
}
//报名查询/审核列表
export function getUserLists(params) {
  return request({
    url: `examUser/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}

// 根据考试查询考试科目
export function getSubjectByExamId(examId) {
  return request({
    url: `/exam-detail/exam/${examId}`,
    method: 'get'
  })
}
// 获取支付二维码
export function getQrPicture(examId) {
  return request({
    url: `/exam-setting/exam/${examId}`,
    method: 'get'
  })
}
